// Mock data for Tamra Developers — replace with backend later

export const SITE_ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_eda42da2-70f8-4554-899c-f8104e4a6469/artifacts/y8rsa645_WhatsApp%20Image%202026-04-29%20at%2010.27.21.jpeg",
  hero: {
    sky: "https://images.unsplash.com/photo-1769184614148-b24ac44feeab?auto=format&fit=crop&w=1920&q=80",
    skyline: "https://images.unsplash.com/photo-1637129078553-10feca4fc4d1?auto=format&fit=crop&w=1920&q=80",
    palms: "https://images.unsplash.com/photo-1623408861409-b58fb2d60315?auto=format&fit=crop&w=1920&q=80",
    building: "https://customer-assets.emergentagent.com/job_eda42da2-70f8-4554-899c-f8104e4a6469/artifacts/3sbu3k0w_elevation%20TAMRA%20DEVELOPERS%208.JPG.jpeg",
    aerial: "https://customer-assets.emergentagent.com/job_eda42da2-70f8-4554-899c-f8104e4a6469/artifacts/x6plr6qd_Tamra%20%2812%29.jpg.jpeg",
    playground: "https://customer-assets.emergentagent.com/job_eda42da2-70f8-4554-899c-f8104e4a6469/artifacts/8jnvbf29_elevation%20TAMRA%20DEVELOPERS%2017.JPG.jpeg",
  },
  inspirations: [
    "https://images.unsplash.com/photo-1638885930125-85350348d266?auto=format&fit=crop&w=1200&q=80",
    "https://images.pexels.com/photos/2462015/pexels-photo-2462015.jpeg?auto=compress&cs=tinysrgb&w=1200",
    "https://images.pexels.com/photos/261041/pexels-photo-261041.jpeg?auto=compress&cs=tinysrgb&w=1200",
    "https://images.pexels.com/photos/36563717/pexels-photo-36563717.jpeg?auto=compress&cs=tinysrgb&w=1200",
    "https://images.pexels.com/photos/33966785/pexels-photo-33966785.jpeg?auto=compress&cs=tinysrgb&w=1200",
    "https://images.pexels.com/photos/8082330/pexels-photo-8082330.jpeg?auto=compress&cs=tinysrgb&w=1200",
  ],
};

export const SITE_SETTINGS_DEFAULT = {
  brandName: "TAMRA",
  brandSubtitle: "DEVELOPERS",
  tagline: "Crafting Skylines, Building Dreams",
  heroHeadline: "Luxury High-Rise Living",
  heroSubline: "Reveal the Full Elegance of Modern Architecture",
  fontPair: "cormorant", // cormorant | playfair | cinzel | marcellus | tenor
  contact: {
    phone: "+91 90000 00000",
    email: "info@tamradevelopers.com",
    address: "Hyderabad, Telangana, India",
    hours: "Mon – Sat · 10:00 AM – 7:00 PM",
  },
  social: {
    instagram: "#",
    facebook: "#",
    youtube: "#",
    linkedin: "#",
  },
};

export const PROJECTS = [
  {
    id: "asteria",
    name: "Tamra Asteria",
    location: "Kompally, Hyderabad",
    type: "3 & 4 BHK Sky Residences",
    status: "Ongoing",
    cover: "https://customer-assets.emergentagent.com/job_eda42da2-70f8-4554-899c-f8104e4a6469/artifacts/3sbu3k0w_elevation%20TAMRA%20DEVELOPERS%208.JPG.jpeg",
    description: "A signature high-rise destination with sculpted skylines, panoramic balconies and a curated water-feature arrival experience.",
    highlights: ["32 Floors", "4 Iconic Towers", "Sky Lounge", "Water Feature Arrival"],
  },
  {
    id: "meridian",
    name: "Tamra Meridian",
    location: "Tellapur, Hyderabad",
    type: "Premium 3 BHK Residences",
    status: "Pre-Launch",
    cover: "https://customer-assets.emergentagent.com/job_eda42da2-70f8-4554-899c-f8104e4a6469/artifacts/x6plr6qd_Tamra%20%2812%29.jpg.jpeg",
    description: "Where the city meets the calm — twin towers nestled in twelve acres of landscaped greens and curated retail boulevards.",
    highlights: ["24 Floors", "12 Acres", "Retail Boulevard", "Forest Trails"],
  },
  {
    id: "vista",
    name: "Tamra Vista",
    location: "Gachibowli, Hyderabad",
    type: "Luxury 4 BHK Sky Villas",
    status: "Coming Soon",
    cover: "https://customer-assets.emergentagent.com/job_eda42da2-70f8-4554-899c-f8104e4a6469/artifacts/8jnvbf29_elevation%20TAMRA%20DEVELOPERS%2017.JPG.jpeg",
    description: "Hand-crafted sky villas with private decks, infinity edges, and an architecture that frames the horizon itself.",
    highlights: ["Sky Villas", "Infinity Pool", "Private Decks", "Concierge"],
  },
];

export const SERVICES = [
  { id: "s1", title: "Residential Development", icon: "Building2", description: "Iconic high-rise residences engineered with global design principles and timeless craftsmanship." },
  { id: "s2", title: "Commercial Spaces", icon: "Briefcase", description: "Grade-A retail boulevards and offices designed to elevate brands and footfalls alike." },
  { id: "s3", title: "Architectural Design", icon: "Compass", description: "In-house design studio shaping façades, interiors and landscapes with measured restraint." },
  { id: "s4", title: "Interior Curation", icon: "Sofa", description: "Bespoke interior packages — finishes, fittings and lighting curated for refined living." },
  { id: "s5", title: "Landscape & Water Features", icon: "Trees", description: "Signature arrival courts, reflective pools and tropical green walks across every Tamra address." },
  { id: "s6", title: "Property Management", icon: "Shield", description: "Full-service post-handover stewardship — concierge, maintenance, security and lifestyle programming." },
];

export const AMENITIES = [
  { id: "a1", name: "Signature Water Feature Arrival", image: "https://images.pexels.com/photos/261041/pexels-photo-261041.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { id: "a2", name: "Sky Infinity Pool", image: "https://images.pexels.com/photos/24461272/pexels-photo-24461272.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { id: "a3", name: "Private Marble Lobby", image: "https://images.pexels.com/photos/36563717/pexels-photo-36563717.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { id: "a4", name: "Premium Wellness Club", image: "https://images.pexels.com/photos/33966785/pexels-photo-33966785.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { id: "a5", name: "Children's Play Garden", image: "https://customer-assets.emergentagent.com/job_eda42da2-70f8-4554-899c-f8104e4a6469/artifacts/8jnvbf29_elevation%20TAMRA%20DEVELOPERS%2017.JPG.jpeg" },
  { id: "a6", name: "Retail Boulevard", image: "https://images.pexels.com/photos/2462015/pexels-photo-2462015.jpeg?auto=compress&cs=tinysrgb&w=1200" },
];

export const TESTIMONIALS = [
  { id: "t1", name: "Aravind Reddy", role: "Resident — Tamra Asteria", quote: "The arrival experience itself feels like a five-star retreat. Tamra has set a new benchmark for high-rise living in Hyderabad." },
  { id: "t2", name: "Priya Sharma", role: "Investor", quote: "Their attention to material, craft and post-sales service is unmatched. Genuinely the most considered developer I've worked with." },
  { id: "t3", name: "Rahul Verma", role: "Architect, Studio Verve", quote: "What Tamra builds reads like architecture, not just real estate. The proportions and finishes show real intent." },
];

export const FAQS = [
  { id: "f1", q: "Where are Tamra's projects located?", a: "Currently across premium pockets of Hyderabad — Kompally, Tellapur and Gachibowli — with new launches planned in Bengaluru." },
  { id: "f2", q: "What configurations do you offer?", a: "3 BHK, 4 BHK and bespoke sky-villa formats, ranging from 1,850 to 5,400 sq.ft." },
  { id: "f3", q: "Are the projects RERA approved?", a: "Yes — every Tamra project is fully RERA-registered. RERA numbers are listed on the respective project page." },
  { id: "f4", q: "Do you offer home-loan assistance?", a: "Yes. We are empanelled with all leading banks and NBFCs and our team manages the documentation end-to-end." },
  { id: "f5", q: "Can I schedule a site visit?", a: "Absolutely — request a visit via the contact form and our relationship manager will confirm your slot within 24 hours." },
];

export const STORY = {
  heading: "TAMRA, REIMAGINED",
  body: "Tamra is the pursuit of a quieter, more considered luxury. Each address fuses contemporary architecture with the warmth of natural materials — copper, stone, timber and water. Our craft lies in restraint: in proportions that feel inevitable, in light that lingers, in skylines that belong to the city yet feel intimately yours.\n\nFrom the curated arrival courts to the rooftops that meet the horizon, every Tamra residence is engineered to age gracefully and live generously.",
};
